<!-- 面试信息 -->
<template>
  <div>
    <zlr-modal v-model="isShow">
      <div class="interview-info">
        <h1>面试信息</h1>
        <Form ref="formValidate"
              :model="formValidate"
              :rules="ruleValidate">
          <FormItem label="是否收到面试"
                    prop="haveInterview"
                    :label-width=224>
            <Select v-model="formValidate.haveInterview"
                    placeholder="Select">
              <Option :value=1>是</Option>
              <Option :value=0>否</Option>
            </Select>
          </FormItem>
          <FormItem label="请选择时区"
                    prop="zone"
                    :label-width=224>
            <Select v-model="formValidate.zone"
                    placeholder="Select">
              <Option :value="item.value"
                      v-for="(item,index) in zoneMap"
                      :key="index">{{item.title}}</Option>
            </Select>
          </FormItem>
          <FormItem label="收到面试邀请的时间"
                    prop="receiveInterviewTime"
                    :label-width=224>
            <DatePicker type="datetime"
                        placeholder="Select date"
                        style="width: 100%;"
                        v-model="formValidate.receiveInterviewTime"></DatePicker>
          </FormItem>
          <FormItem label="第一次面试时间"
                    prop="interviewOneTime"
                    :label-width=224>
            <DatePicker type="datetime"
                        placeholder="Select date"
                        style="width: 100%;"
                        v-model="formValidate.interviewOneTime"></DatePicker>
          </FormItem>
          <FormItem label="上传收到面试邀请的文件"
                    prop="interviewUrl"
                    class="interview-info-upload-con">
            <div class="interview-info-upload">
              <upload v-model="formValidate.interviewUrl"
                      :size=10
                      :path="`interview/${programId}`"
                      ref="upload"></upload>
              <div class="interview-info-upload-prompt">只能上传10MB大小以下的文件</div>
            </div>
          </FormItem>
          <div class="interview-info-btn">
            <Button @click="closeHandle">关闭</Button>
            <Button class="btn-sub"
                    :loading="isSub"
                    @click="saveHandle">保存</Button>
          </div>
        </Form>
      </div>
    </zlr-modal>
  </div>
</template>

<script>
// api
import { addProjectInterview } from '@/api/project'
// components
import ZlrModal from '_c/modal/modal'
import Upload from '_c/upload/upload'
// constant
import { zoneMap } from '@/constant'
export default {
  name: 'project-interview-info',
  props: ['interviewData'],
  components: {
    ZlrModal,
    Upload
  },
  data () {
    return {
      isShow: false,
      programId: this.$route.params.id,
      zoneMap,
      formValidate: {
      },
      ruleValidate: {
        haveInterview: [{ required: true, message: '请选择是否收到面试' }],
        zone: [{ required: true, message: '请选择时区' }],
        receiveInterviewTime: [{ required: true, message: '请选择收到面试邀请的时间' }],
        interviewOneTime: [{ required: true, message: '请选择第一次面试时间' }],
        interviewUrl: [{ required: true, message: '请上传收到面试邀请的文件' }]
      },
      isSub: false
    }
  },
  computed: {},
  mounted () { },
  methods: {
    makeData () {
      let data = this.interviewData
      this.formValidate = {
        haveInterview: data.haveInterview,
        zone: data.zone,
        receiveInterviewTime: data.receiveInterviewTime ? new Date(data.receiveInterviewTime) : '',
        interviewOneTime: data.interviewOneTime ? new Date(data.interviewOneTime) : '',
        interviewUrl: ''
      }
    },
    // 保存
    saveHandle () {
      this.$refs['formValidate'].validate((valid) => {
        if (valid) {
          let data = Object.assign({}, this.formValidate)
          data.projectId = this.programId
          this.isSub = true
          addProjectInterview(data).then(res => {
            this.$zlr_message('保存成功', 'success')
            this.$emit('on-success')
            this.closeHandle()
          }).catch(error => {
            this.$zlr_message(error.message, 'error')
          }).then(() => {
            this.isSub = false
          })
        }
      })
    },
    showHandle () {
      this.isShow = true
    },
    // 重置数据
    resetData () {
      this.$refs['formValidate'].resetFields()
      this.$refs['upload'].stopUplod()
    },
    // 关闭
    closeHandle () {
      this.isShow = false
    }
  },
  watch: {
    isShow (newValue) {
      if (!newValue && !this.interviewData.zone) {
        this.resetData()
      }
    },
    interviewData (newValue) {
      this.makeData()
    }
  }
}
</script>
<style lang='less' scoped>
</style>
